import TradeAgreements from './TradeAgreements';
export default TradeAgreements;
